import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import { formatCurrency } from "Helpers/Format";
import moment from "Helpers/MomentCompat";

import UseServices from "Hooks/UseServices";

import * as S from "./styles";

// Visão POR VÍNCULO na aba "Projetos Apresentados" (A14 — D21/D27): painel
// SOMENTE LEITURA na linha expandida com o que aquele patrocinador vê. A
// edição é no PROJETO — o link abaixo abre a tela dele em nova aba.
const LinkOverview = ({ projectSponsorId }) => {
  const { api } = UseServices();

  const [overview, setOverview] = useState(null);

  useEffect(() => {
    if (!projectSponsorId) return;

    api
      .post("/select-projects/link-overview", {
        project_sponsor_id: projectSponsorId,
      })
      .then((response) => setOverview(response.data))
      .catch((error) => HTTPErrorCallback(error));
    // eslint-disable-next-line
  }, [projectSponsorId]);

  if (!overview) return <S.Wrapper>Carregando…</S.Wrapper>;

  const period = (event) =>
    !event.finish_date ||
    moment(event.finish_date).format("YYYY-MM-DD") ===
      moment(event.date).format("YYYY-MM-DD")
      ? moment(event.date).format("DD/MM/YYYY")
      : `${moment(event.date).format("DD/MM/YYYY")} – ${moment(
          event.finish_date,
        ).format("DD/MM/YYYY")}`;

  return (
    <S.Wrapper>
      <S.Header>
        <strong>Visão do patrocinador neste vínculo (somente leitura)</strong>
        <a
          href={`/admin/projects/update/${overview.project_id}`}
          target="_blank"
          rel="noreferrer"
        >
          Abrir projeto para editar
        </a>
      </S.Header>

      <S.Sections>
        <S.SectionBlock>
          <h3>Valor Aportado</h3>
          {!overview.quotas?.length ? (
            <span>Nenhum valor aportado.</span>
          ) : null}
          {/* Sem o campo Nome (D6 da parte 2): esta seção já é do VÍNCULO, e o
              patrocinador é implícito — sobra o valor. */}
          {overview.quotas?.map((quota) => (
            <span key={quota.id}>{formatCurrency(quota.value)}</span>
          ))}
        </S.SectionBlock>

        <S.SectionBlock>
          <h3>Contrapartidas</h3>
          {!overview.counterparts?.length ? (
            <span>Nenhuma contrapartida.</span>
          ) : null}
          {overview.counterparts?.map((counterpart) => (
            <span key={counterpart.id}>
              {counterpart.description} ({counterpart.status})
            </span>
          ))}
        </S.SectionBlock>

        <S.SectionBlock>
          <h3>Cronograma</h3>
          {!overview.events?.length ? <span>Nenhum evento.</span> : null}
          {overview.events?.map((event) => (
            <span key={event.id}>
              {event.name} — {period(event)}
            </span>
          ))}
        </S.SectionBlock>

        <S.SectionBlock>
          <h3>Mensagens</h3>
          <span>
            {overview.conversations_count || 0} conversa(s) neste vínculo
          </span>
        </S.SectionBlock>

        <S.SectionBlock>
          <h3>Materiais Aprovados</h3>
          {!overview.approved_materials?.length ? (
            <span>Nenhum material.</span>
          ) : null}
          {overview.approved_materials?.map((material) => (
            <a
              key={material.id}
              href={material.file_src}
              target="_blank"
              rel="noreferrer"
            >
              {/* `title` é o nome que o proponente deu na sessão "Materiais"
                  (19/09/2026). Sem ele esta tela mostrava o nome do arquivo
                  enquanto o patrocinador via o nome do material — o mesmo
                  item com dois nomes em superfícies diferentes. */}
              {material.title || material.file_name || "Arquivo"}
            </a>
          ))}
        </S.SectionBlock>

        <S.SectionBlock>
          <h3>Álbum</h3>
          {!overview.gallery?.length ? <span>Nenhuma imagem.</span> : null}
          <S.Thumbs>
            {overview.gallery?.map((image) => (
              <img key={image.id} src={image.file_src} alt={image.name} />
            ))}
          </S.Thumbs>
        </S.SectionBlock>
      </S.Sections>
    </S.Wrapper>
  );
};

export default LinkOverview;
